// @mui material components
import Card from "@mui/material/Card";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Snackbar from "@mui/material/Snackbar";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React, { useState } from "react";
import MDButton from "../../../../components/MDButton";
import { useApi } from "../../../../context/api.js";
import Alert from "@mui/material/Alert";

const MAIL_DATA = {
  "totp-code": {
    name: "{name}",
    code: "123456",
  },
  "reset-password": {
    name: "{name}",
    code: "123456",
  },
  "notifications/validation_requested": {
    name: "{name}",
    from: "{from}",
  },
};

function AdminMailTest() {
  const [mailTemplate, setMailTemplate] = useState("");
  const api = useApi();

  // Result message
  const [error, setError] = useState({ open: false });
  const closeError = () => setError((e) => ({ ...e, open: false }));

  const sendTestMail = () => {
    if (mailTemplate && MAIL_DATA[mailTemplate]) {
      api
        .sendTestMail(mailTemplate, MAIL_DATA[mailTemplate])
        .then((res) => {
          if (res) {
            setError({ open: true, type: "success" });
          } else {
            setError({ open: true, type: "error" });
          }
        })
        .catch((err) => {
          setError({ open: true, type: "error" });
        });
    }
  };

  return (
    <Card>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Mail test
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        <MDBox mb={2}>
          <FormControl fullWidth>
            <InputLabel id="email-template-label">Gabarit de courriel</InputLabel>
            <Select
              labelId="email-template-label"
              id="email-template"
              value={mailTemplate}
              label="Gabarit de courriel"
              onChange={(e) => setMailTemplate(e.target.value)}
            >
              <MenuItem value={"totp-code"}>TOTP code</MenuItem>
              <MenuItem value={"reset-password"}>Reset password</MenuItem>
              <MenuItem value={"notifications/validation_requested"}>Validation requested</MenuItem>
            </Select>
          </FormControl>
        </MDBox>
        <MDBox mb={2}>
          <MDButton
            color="info"
            disabled={!mailTemplate || !MAIL_DATA[mailTemplate]}
            onClick={sendTestMail}
          >
            Envoyer
          </MDButton>
        </MDBox>
      </MDBox>
      <Snackbar
        open={error.open}
        autoHideDuration={5000}
        onClose={closeError}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert variant="filled" severity={error.type}>
          {error.type === "error" && "Une erreur est survenue lors de l'envoi du courriel."}
          {error.type === "success" && "Le courriel a été correctement envoyé."}
        </Alert>
      </Snackbar>
    </Card>
  );
}

export default AdminMailTest;
